// /settings/protocols — «Протоколы» (010, T038; FR-001, FR-003; сценарий 8): схемы шаблонов
// с карточкой справа и блок «Общие правила». Право — templates.read (администратор клиента).
// Поиск, состояние, сортировка и открытая схема — в адресе (?q=&state=&sort=&template=).
import { createFileRoute, useNavigate } from '@tanstack/react-router';
import { useCallback } from 'react';
import { ProtocolsPage } from '../../../features/protocols/ProtocolsPage.tsx';
import { parseProtocolsSearch } from '../../../features/protocols/search.ts';
import type { ProtocolsSearch } from '../../../features/protocols/search.ts';
import { requireSection } from '../../../shell/permissions.ts';

export const Route = createFileRoute('/_app/_settings/settings/protocols')({
  validateSearch: parseProtocolsSearch,
  beforeLoad: requireSection('protocols'),
  staticData: { crumb: 'Протоколы' },
  component: ProtocolsRoute,
});

function ProtocolsRoute() {
  const search = Route.useSearch();
  const navigate = useNavigate();
  const onSearchChange = useCallback(
    (next: ProtocolsSearch) =>
      void navigate({ to: '/settings/protocols', search: next, replace: true }),
    [navigate],
  );
  return <ProtocolsPage search={search} onSearchChange={onSearchChange} />;
}
